var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnSenegal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_23241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0H40.0031V45H60V0Z",
    fill: "#0B7226"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0029 0H20.0061V45H40.0029V0Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0059 0H-0.000389099V45H20.0059V0Z",
    fill: "#BC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9373 20.5125H21.2061L26.5123 24.6L24.5717 31.0969L29.8779 27.0094L35.1842 30.9094L33.2436 24.6L38.5498 20.5125H32.0061L29.8779 13.8281L27.9373 20.5125Z",
    fill: "#0B7226"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_23241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnSenegal);
export default __webpack_public_path__ + "static/media/sn Senegal.4444299b71bbb377369d1ea36c42c9e4.svg";
export { ForwardRef as ReactComponent };